module.exports = __webpack_public_path__ + "img/sumdes-page_1248.cce8565b.png";